import type { DataShape } from '../../services';

export const PREFIX: keyof Pick<DataShape, 'legacy_widget'> = 'legacy_widget';
